import { get } from "../../utils/helpers";
import { toDDCCustomer } from "../shared/transforms";

// Map the internal data model to the DDC Backend Customer object
// customerFormState -> DDCCustomer
export const toDDCCustomerCeline = {
  ...toDDCCustomer,
  title: (value: any, propName?: string, input?: any) => {
    return {
      title: get(input, "honorificPrefixMy") || get(input, "honorificPrefix")
    };
  }
};
